export default {
	namespaced: true,
	state: {
		jsonAlumno: [],
		jsonCampusAlumno: [],
		jsonCursoAlumno: [],
		jsonEvaluacionAlumno: [],
		jsonRegionAlumno: [],
		jsonComunaAlumno: [],
		activeAlumno: "",
		jsonCoordinadora: [],
		empresasCliente: [],
		listadoAlumnosBusqueda: [],
	},
	mutations: {
		chargeAlumno(state, payload) {
			state.jsonAlumno = payload;
		},
		chargelistadoAlumnosBusqueda(state, payload) {
			state.listadoAlumnosBusqueda = payload;
		},
		updateEdicionAlumno(state, payload) {
			state.jsonCoordinadora.edicionAlumno = payload;
		},
		updateInscripcionCurso(state, payload) {
			state.jsonCoordinadora.inscripcionCurso = payload;
		},
		updateRecalculoNota(state, payload) {
			state.jsonCoordinadora.recalculoNota = payload;
		},
		updateCertificadoAlumno(state, payload) {
			state.jsonCoordinadora.certificado = payload;
		},
		updateReportesAlumno(state, payload) {
			state.jsonCoordinadora.cargaReportes = payload;
		},
		chargeCoordinadora(state, payload) {
			state.jsonCoordinadora = payload;
		},
		addJsonAlumno(state, payload) {
			state.jsonAlumno.push(payload);
		},
		addMultipleAlumno(state, payload) {
			payload.map((alumno) => state.jsonAlumno.push(alumno));
		},
		chargeCampusAlumno(state, payload) {
			state.jsonCampusAlumno = payload;
		},
		chargeCursoAlumno(state, payload) {
			state.jsonCursoAlumno = payload;
		},
		chargeEvaAlumno(state, payload) {
			state.jsonEvaluacionAlumno = payload;
		},
		chargeRegion(state, payload) {
			state.jsonRegionAlumno = payload;
		},
		chargeComuna(state, payload) {
			state.jsonComunaAlumno = payload;
		},
		activeAlumno(state, payload) {
			state.activeAlumno = payload;
		},
		updateNotaAlumno(state, payload) {
			state.jsonAlumno = state.jsonAlumno.map((al) =>
				al.idAlumno === payload.idAlumno
					? {
							...al,
							promedioFinal: "-",
							estado: 2,
							evaluacion: al.evaluacion.map((ev) =>
								ev.idEvaluacion === payload.idEvaluacion
									? { ...ev, nota: "-" }
									: { ...ev }
							),
					  }
					: { ...al }
			);
		},
	},
	actions: {
		updateListadoAlumnosBusqueda({commit},payload){
          commit("chargelistadoAlumnosBusqueda",payload);
		},
		updateJsonCoordinadora({ commit }, payload) {
			commit("chargeCoordinadora", payload);
		},
		updateEdicionAlumno({ commit }, payload) {
			commit("updateEdicionAlumno", payload);
		},
		updateInscripcionCurso({ commit }, payload) {
			commit("updateInscripcionCurso", payload);
		},
		updateRecalculoNota({ commit }, payload) {
			commit("updateRecalculoNota", payload);
		},
		updateReportesAlumno({ commit }, payload) {
			commit("updateReportesAlumno", payload);
		},
		updateCertificadoAlumno({ commit }, payload) {
			commit("updateCertificadoAlumno", payload);
		},
		updateJsonAlumno({ commit }, payload) {
			commit("chargeAlumno", payload);
		},
		addJsonAlumno({ commit }, payload) {
			commit("addJsonAlumno", payload);
		},
		addMultipleAlumno({ commit }, payload) {
			commit("addMultipleAlumno", payload);
		},
		updateCampusJson({ commit }, payload) {
			commit("chargeCampusAlumno", payload);
		},
		updateCursoJson({ commit }, payload) {
			commit("chargeCursoAlumno", payload);
		},
		updateEvaluacionJson({ commit }, payload) {
			commit("chargeEvaAlumno", payload);
		},
		updateRegionJson({ commit }, payload) {
			commit("chargeRegion", payload);
		},
		updateComunaJson({ commit }, payload) {
			commit("chargeComuna", payload);
		},
		addActiveAlumno({ commit }, payload) {
			commit("activeAlumno", payload);
		},
		updateNotaAlumno({ commit }, payload) {
			commit("updateNotaAlumno", payload);
		},
	},
	getters: {},
};
